import { DataBean } from "../DataBean";

export class ExportProductionPlan extends DataBean {



    public async exportProductionPlan(year: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_exportProductionPlan_Number", [year]);
    }

}